import React, { useState } from "react";
import { Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import CustomRow from "../../shared/costum-row/costum-row";

import "./styles.scss";
import useBreakpoints from "../../hooks/use-breakpoints";
import { BREAKPOINTS, BUTTON_VARIANTS } from "../../constants/styles";
import CustomButton from "../../shared/custom-button/custom-button";
import { ARROW_LIGHT, ARROW_OPENER } from "../../constants/svgs";
import { VIEWS } from "../../constants/global";
import { routes } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

interface BlogPost {
  id: number;
  title: string;
  date: string;
  category: string;
  author: string;
  description: string;
  imageSrc: string;
}

interface BlogTeaserProps {
  blogPost: BlogPost;
}

const BlogTeaser: React.FC<BlogTeaserProps> = ({ blogPost }) => {
  const currentBreakpoint = useBreakpoints();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  const handleClick = () => {
    navigate(`${routes[VIEWS.BLOG_DETAILS].staticPath}/${blogPost.id}`);
  };

  if (isMobile) {
    return (
      <CustomRow
        className="BlogTeaser"
        gutter={[0, 20]}
        justify="space-between"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <Col span={24}>
          <CustomRow justify="space-between">
            <Col>
              <Text className="BlogTeaser-container-date">{blogPost.date}</Text>
            </Col>
            <Col className="BlogTeaser-arrow">
              {isHovered ? ARROW_OPENER : ARROW_LIGHT}
            </Col>
          </CustomRow>
        </Col>

        <Col span={24}>
          <Title className="BlogTeaser-container-title mt-3xs mb-3xs">
            {blogPost.title}
          </Title>
        </Col>
        <Col span={24} className="BlogTeaser-button">
          <CustomButton
            btnVariant={BUTTON_VARIANTS.TEXT}
            onClick={handleClick}
          >
            Read more
          </CustomButton>
        </Col>
      </CustomRow>
    );
  }

  return (
    <CustomRow
      className="BlogTeaser pt-lg pb-lg"
      gutter={[0, 20]}
      justify="space-between"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <Col xxl={18} xl={18} lg={21} md={21} sm={24} xs={24}>
        <div className="BlogTeaser-container">
          <Text className="BlogTeaser-container-date">{blogPost.date}</Text>
          <Title className="BlogTeaser-container-title mt-3xs mb-3xs">
            {blogPost.title}
          </Title>
        </div>
      </Col>
      <Col className="BlogTeaser-arrow">
        {isHovered ? ARROW_OPENER : ARROW_LIGHT}
      </Col>
    </CustomRow>
  );
};

export default BlogTeaser;
